/* eslint-disable max-len, max-lines, no-shadow, quotes */

import API from "../modules/API";
import {Helmet} from "react-helmet";
import Helper from "../../shared/modules/Helper";
import {Link} from "react-router-dom";
import MemberDiscountHelper from "../../shared/modules/MemberDiscountHelper";
import ProductRating from "./ProductRating";
import PromoPriceVariantHelper from "../modules/PromoPriceVariantHelper";
import PropTypes from "prop-types";
import React from "react";
import ScarcityMessaging from "../../bundles/Cart/ScarcityMessaging";
import Swatch from "../../bundles/Product/components/Swatch";
import _get from "lodash/get";
import {withCookies} from "react-cookie";

class Info extends React.PureComponent {

  static propTypes = {
    "buyItNowEligible": PropTypes.bool.isRequired,
    "clearBuyItNowEligibility": PropTypes.func.isRequired,
    "cookies": PropTypes.object.isRequired,
    "customerId": PropTypes.string.isRequired,
    "fetchBuyItNowEligibility": PropTypes.func.isRequired,
    "fetchCustomerCredits": PropTypes.func.isRequired,
    "fetchOrderInfo": PropTypes.func.isRequired,
    "fetchPDPrices": PropTypes.func.isRequired,
    "fromProductDetailsModal": PropTypes.bool,
    "handleSwatchClick": PropTypes.func,
    "history": PropTypes.object,
    "itemAvailability": PropTypes.number,
    "location": PropTypes.object,
    "nav": PropTypes.bool,
    "orderInfo": PropTypes.object.isRequired,
    "parentProps": PropTypes.object.isRequired,
    "pdPrices": PropTypes.object.isRequired,
    "previewSwapping": PropTypes.bool,
    "showClearancePrice": PropTypes.bool.isRequired
  };

  static defaultProps = {
    "buyItNowEligible": false,
    "customerId": "",
    "fromProductDetailsModal": false,
    "handleSwatchClick": null,
    "history": {},
    "itemAvailability": null,
    "location": null,
    "nav": true,
    "orderInfo": {},
    "pdPrices": {},
    "previewSwapping": false
  };

  componentDidMount = () => {
    const {
      customerId,
      fetchCustomerCredits
    } = this.props;

    fetchCustomerCredits(customerId);
    this.fetchOrderAndPriceInfo();
    this.fetchBuyItNowEligibility();
  }

  componentDidUpdate = (prevProps) => {
    const {"parentProps": {"productDescriptor": {"id": oldId}}} = prevProps;
    const {"parentProps": {"productDescriptor": {"id": newId}}} = this.props;

    this.fetchOrderAndPriceInfo();

    if (oldId !== newId) {
      this.fetchBuyItNowEligibility();
    }
  }

  componentWillUnmount = () => {
    const {clearBuyItNowEligibility} = this.props;
    clearBuyItNowEligibility();
  }

  displayClearancePrice = () => {
    const {location, showClearancePrice} = this.props;

    return showClearancePrice || _get(location, "state.fromClearancePage", false);
  }

  fetchBuyItNowEligibility = () => {
    const {customerId, fetchBuyItNowEligibility, "parentProps": {"productDescriptor": {id}}} = this.props;

    if (!customerId) {
      fetchBuyItNowEligibility(id);
    }
  }

  fetchOrderAndPriceInfo = () => {
    const {
      customerId,
      "fetchOrderInfo": fetchPDOrderInfo,
      fetchPDPrices,
      "parentProps": {"productDescriptor": {id}},
      orderInfo,
      pdPrices
    } = this.props;

    if (customerId) {
      if (Object.keys(orderInfo).length === 0 || !orderInfo[id]) {
        fetchPDOrderInfo([id]);
      }

      if (Object.keys(pdPrices).length === 0 || !pdPrices[id]) {
        fetchPDPrices([id]);
      }
    }
  }

  handleSwatchClick = (event) => {
    const {handleSwatchClick, nav} = this.props;
    if (nav) {
      return;
    }

    handleSwatchClick(event.currentTarget.children[0].getAttribute("id"));
  };

  getDiscountVariantPrice = () => {
    const {
      "parentProps": {
        "productDescriptor": {
          "details": {
            "insider_price_dollars_varB": insiderPriceVariantBDollarsOnPD,
            "insider_price_dollars_varC": insiderPriceVariantCDollarsOnPD
          },
          id
        }
      },
      pdPrices
    } = this.props;

    const insiderPriceMap = new Map([
      [
        "member_discount_var_b",
        insiderPriceVariantBDollarsOnPD
      ],
      [
        "member_discount_var_c",
        insiderPriceVariantCDollarsOnPD
      ]
    ]);

    if (!API.CUSTOMER_ID) {
      const memberVariant = MemberDiscountHelper.getMemberDiscountVariant();

      if (!memberVariant) return "";
      return insiderPriceMap.get(memberVariant);
    }
    if (API.CUSTOMER_ID && pdPrices[id]) return pdPrices[id].member_price;
    return "";
  }

  getMemberPrice = () => {
    const {"parentProps": {"productDescriptor": {id, "details": {"insider_price_dollars": insiderPriceDollarsOnPD}}}, pdPrices} = this.props;
    if (!API.CUSTOMER_ID) return insiderPriceDollarsOnPD;
    else if (API.CUSTOMER_ID && pdPrices[id]) {
      return pdPrices[id].member_price;
    }
    return "";
  }

  getRetailPrice = () => {
    const {"parentProps": {"productDescriptor": {id, "details": {"retail_price": retailPriceOnPD}}}, pdPrices} = this.props;
    if (!API.CUSTOMER_ID) return retailPriceOnPD;
    else if (API.CUSTOMER_ID && pdPrices[id]) {
      return pdPrices[id].retail_price;
    }
    return "";
  }

  getUniqueColorGroups = (colorGroups) => { // eslint-disable-line arrow-body-style
    if (!colorGroups || !colorGroups.length) return colorGroups;
    return colorGroups.filter((obj, index) => colorGroups.findIndex(item => item.product_name === obj.product_name) === index);
  }

  isClearanceItem = () => {
    const {orderInfo, parentProps, pdPrices} = this.props;
    const {productDescriptor} = parentProps;
    const {id, "details": {"clearance_price": noCustomerClearancePrice}} = productDescriptor;

    const clearancePrice = pdPrices[id]
      ? pdPrices[id].clearance_price
      : noCustomerClearancePrice;

    if (API.CUSTOMER_ID) {
      const availableClearanceStore = orderInfo[id] ? orderInfo[id]["clearance?"] : false;
      return availableClearanceStore && clearancePrice && this.displayClearancePrice();
    }

    return clearancePrice && this.displayClearancePrice();
  }

  nonmemberShouldSeeBIN = () => {
    const {buyItNowEligible} = this.props;
    return buyItNowEligible;
  }

  renderBINPrice = () => {
    if (MemberDiscountHelper.shouldSeeMemberDiscountVariant()) return null;

    const memberPrice = this.getMemberPrice();
    const retailPrice = this.getRetailPrice();

    return (
      <React.Fragment>
        <p className="styled_h5 inline mb0 pb0 pr16">
          {`retail price $${Helper.formatPriceCents(retailPrice)}`}
        </p>
        {memberPrice !== retailPrice &&
          <p className="color-tangerine-1 inline-block mt0 mb0 pb0">
            {`member price $${Helper.formatPriceCents(memberPrice)}`}
          </p>
        }
      </React.Fragment>
    );
  }

  renderPrice = () => {
    const memberPrice = this.getMemberPrice();
    const retailPrice = this.getRetailPrice();

    if (!API.CUSTOMER_ID) {
      return (
        <p className={`styled_h5 inline mb0 pb0 ${this.isClearanceItem() ? "strike pr0" : "pr16"}`}>
          {`$${Helper.formatPriceCents(retailPrice)}`}
        </p>
      );
    }

    if (!this.nonmemberShouldSeeBIN() && !MemberDiscountHelper.shouldSeeMemberDiscountVariant() && memberPrice) {
      return (
        <React.Fragment>
          <p className="styled_h5 mb0 pb0 mr8 inline">
            {`member $${Helper.formatPriceCents(memberPrice)}`}
          </p>
          {memberPrice !== retailPrice &&
            <p className="styled_h5 inline strike mb0 pb0">
              {`retail $${Helper.formatPriceCents(retailPrice)}`}
            </p>
          }
        </React.Fragment>
      );
    }

    const discountVariantPrice = this.getDiscountVariantPrice();

    if (!discountVariantPrice) return null;

    return (
      <React.Fragment>
        <p className="styled_h5 inline mb0 pb0 pr16">
          {`member $${Helper.formatPriceCents(discountVariantPrice)}`}
        </p>
        {discountVariantPrice !== retailPrice &&
          <p className="styled_h5 inline strike mb0 pb0">
            {`retail $${Helper.formatPriceCents(retailPrice)}`}
          </p>
        }
      </React.Fragment>
    );
  }

  getPromoPriceInfo = () => {
    const {
      cookies,
      "parentProps": {"productDescriptor": {"promo_price_info": promoPriceInfo}}
    } = this.props;

    const autoAppliedPromoCode = cookies.get("auto_applied_promo_code");

    return promoPriceInfo && autoAppliedPromoCode && promoPriceInfo[autoAppliedPromoCode];
  }

  renderClearancePriceInfo = () => {
    const {
      cookies,
      "parentProps": {"productDescriptor": {"details": {"clearance_price": clearancePrice}}}
    } = this.props;
    const {"clearance_price": clearancePromoPrice, "discount_text": discountText} = this.getPromoPriceInfo() || {};
    const retailPrice = `$${Helper.formatPriceCents(this.getRetailPrice())}`;
    const experimentVariant = cookies.get("item_level_promo_experiment_variant");

    if (clearancePromoPrice && PromoPriceVariantHelper.shouldSeePromoPrice(experimentVariant)) {
      return PromoPriceVariantHelper.renderPromoPriceOnProductPage(retailPrice, clearancePromoPrice);
    }

    if (clearancePromoPrice && discountText && PromoPriceVariantHelper.shouldSeePromoPriceAndDiscount(experimentVariant)) {
      return PromoPriceVariantHelper.renderPromoPriceAndDiscountOnProductPage(retailPrice, clearancePromoPrice, discountText);
    }

    return (
      <React.Fragment>
        {this.renderPrice()}
        <p className="styled_h5 mb0 pb0 mr8 inline color-primary">
          {`clearance ${clearancePrice}`}
        </p>
      </React.Fragment>
    );
  }

  renderPriceInfo = () => {
    const {cookies} = this.props;
    const {price, "discount_text": discountText} = this.getPromoPriceInfo() || {};
    const retailPrice = `$${Helper.formatPriceCents(this.getRetailPrice())}`;
    const experimentVariant = cookies.get("item_level_promo_experiment_variant");

    if (price && PromoPriceVariantHelper.shouldSeePromoPrice(experimentVariant)) {
      return PromoPriceVariantHelper.renderPromoPriceOnProductPage(retailPrice, price);
    }

    if (price && discountText && PromoPriceVariantHelper.shouldSeePromoPriceAndDiscount(experimentVariant)) {
      return PromoPriceVariantHelper.renderPromoPriceAndDiscountOnProductPage(retailPrice, price, discountText);
    }

    return this.renderPrice();
  }

  render () { // eslint-disable-line complexity
    const {
      fromProductDetailsModal,
      handleSwatchClick,
      history,
      itemAvailability,
      "location": {"state": locationState},
      nav,
      orderInfo,
      "parentProps": {
        "productDescriptor": {
          id,
          "details": {
            "color_name": colorName,
            "designer": designerName,
            "kind_name": kindName,
            "group_name": groupName,
            "metal_groups": metalGroups,
            "metal_name": metalName,
            "natural_stone_color_groups": naturalStoneColorGroups,
            "natural_stone_name": naturalStoneName,
            "product_name": productName,
            "ratings": {
              average,
              count
            },
            "ring_size": ringSize,
            "url": productUrl
          }
        }
      },
      previewSwapping,
      showClearancePrice
    } = this.props;
    const prevPath = _get(locationState, "prevPath", "/jewelry");
    const duplicatesAreHappeningIGuess = [
      groupName,
      metalName
    ].includes(productName);
    const filterOut = [];
    const showColorArea = (duplicatesAreHappeningIGuess && colorName !== "None") || !duplicatesAreHappeningIGuess;
    const tmp = [];
    const availableClearanceStore = orderInfo[id] ? orderInfo[id]["clearance?"] : false;
    const uniqueColors = this.getUniqueColorGroups(naturalStoneColorGroups[metalName]);

    if (kindName === "Ring" && naturalStoneColorGroups[metalName]) {
      for (const naturalStoneColorGroup of naturalStoneColorGroups[metalName]) {
        if (!tmp.includes(naturalStoneColorGroup.product_name)) {
          tmp.push(naturalStoneColorGroup.product_name);
          filterOut.push(naturalStoneColorGroup.id);
        }
      }
    }

    return (
      <React.Fragment>
        <Helmet>
          <title>
            {`Rocksbox: ${groupName} by ${designerName}`}
          </title>
        </Helmet>
        <div
          id="Info"
        >
          <p
            className="styled_h5"
            id="designerName"
          >
            {designerName}
          </p>
          <h1
            className="styled_h3 left"
            id="productName"
          >
            {groupName}
          </h1>
          <div id="scarcityMessaging">
            <ScarcityMessaging
              productDescriptorCount={itemAvailability}
            />
          </div>
          <div id="Prices">
            {this.nonmemberShouldSeeBIN() &&
              this.renderBINPrice()
            }
            {this.isClearanceItem() && this.renderClearancePriceInfo()}

            {!this.isClearanceItem() && this.renderPriceInfo()}
          </div>
          <ProductRating
            average={average}
            count={count}
            forGrid={false}
            fromClearancePage={showClearancePrice}
            fromProductDetailsModal={fromProductDetailsModal}
            history={history}
            previewSwapping={previewSwapping}
            productUrl={productUrl}
          />
          {API.CUSTOMER_ID && availableClearanceStore && showClearancePrice &&
            <div className="final-and-credit-notice small">
              <p>
                * Final Sale. Credit does not apply. Sale items are all gently worn and may have visible signs of wear.
              </p>
            </div>
          }
          <div className="color-black-border mv10" />
          <div className="pd-metal-info-box">
            <div>
              <p className="styled_h6 inline bold">
                Metal
              </p>
              {" — "}
              <p className="styled_h6 inline">
                {metalName}
              </p>
            </div>
            <div
              className="mt4"
              id="Metals"
            >
              {metalGroups.length > 1 && metalGroups.map(metalGroup =>
                <Swatch
                  active={metalName === metalGroup}
                  fromClearance={this.displayClearancePrice()}
                  handleSwatchClick={handleSwatchClick}
                  id={naturalStoneColorGroups[metalGroup][0].id}
                  key={metalGroup}
                  nav={nav}
                  storePath={prevPath || "/jewelry"}
                  swatchName={metalGroup}
                  url={naturalStoneColorGroups[metalGroup][0].url}
                />)}
            </div>
          </div>
          {showColorArea &&
          <div className="pd-color-info-box">
            <div>
              <div className="mt4">
                <p className="styled_h6 inline bold">
                  Color
                </p>
                {" — "}
                <p className="styled_h6 inline">
                  {[
                    groupName,
                    metalName
                  ].indexOf(productName) > -1
                    ? naturalStoneName || colorName
                    : productName}
                </p>
              </div>
              <div
                className="mt4"
                id="Colors"
              >
                {uniqueColors && uniqueColors.length > 1 && uniqueColors.map(naturalStoneColorGroup =>
                  <Swatch
                    active={naturalStoneColorGroup.product_name === productName}
                    fromClearance={this.displayClearancePrice()}
                    handleSwatchClick={handleSwatchClick}
                    hidden={kindName === "Ring" && !filterOut.includes(naturalStoneColorGroup.id)}
                    id={naturalStoneColorGroup.id}
                    key={`Color Swatch ${naturalStoneColorGroup.id}`}
                    nav={nav}
                    productName={naturalStoneColorGroup.product_name}
                    storePath={prevPath || "/jewelry"}
                    swatchName={naturalStoneColorGroup.name === "None"
                      ? metalName
                      : naturalStoneColorGroup.name}
                    url={naturalStoneColorGroup.url}
                  />)}
              </div>
            </div>
          </div>}
          {kindName === "Ring" &&
          <div>
            <div className="mt4">
              <h6 className="inline bold">
                Size
              </h6>
              {" — "}
              <h6 className="inline">
                {ringSize}
              </h6>
            </div>
            {ringSize !== "Adjustable" &&
            <div
              className="mt4"
              id="Sizes"
            >
              {naturalStoneColorGroups[metalName] && naturalStoneColorGroups[metalName].
                filter(naturalStoneColorGroup => naturalStoneColorGroup.product_name === productName).
                sort((firstProduct, secondProduct) => parseInt(firstProduct.ring_size, 10) - parseInt(secondProduct.ring_size, 10)). // eslint-disable-line max-len
                map(naturalStoneColorGroup =>
                  (naturalStoneColorGroup.url === location.pathname || !nav
                    ? (
                      <div
                        className={naturalStoneColorGroup.ring_size === ringSize
                          ? "circle"
                          : ""}
                        key={naturalStoneColorGroup.product_name + naturalStoneColorGroup.ring_size}
                        onClick={this.handleSwatchClick}
                      >
                        <h6
                          className={naturalStoneColorGroup.ring_size === ringSize
                            ? "color-content"
                            : ""}
                          id={naturalStoneColorGroup.id}
                        >
                          {naturalStoneColorGroup.ring_size}
                        </h6>
                      </div>)
                    : (
                      <Link
                        className={naturalStoneColorGroup.ring_size === ringSize
                          ? "circle"
                          : ""}
                        key={naturalStoneColorGroup.product_name + naturalStoneColorGroup.ring_size}
                        to={naturalStoneColorGroup.url === location.url
                          ? null
                          : naturalStoneColorGroup.url + location.search}
                      >
                        <h6
                          className={naturalStoneColorGroup.ring_size === ringSize
                            ? "color-content"
                            : ""}
                          id={naturalStoneColorGroup.id}
                        >
                          {naturalStoneColorGroup.ring_size}
                        </h6>
                      </Link>)))}
            </div>}
          </div>}
          <div className="color-black-border mv10" />
        </div>
      </React.Fragment>
    );
  }
}

export default withCookies(Info);
